import { Box, Typography } from "@mui/material";
import { Euro } from "@mui/icons-material";
import { ColoredLabelChip } from "../../../../components/chips/ColoredLabelChip";
import { formatDateCompact } from "../../../../utils/dateUtils";
import { BaseTimelineItem } from "./BaseTimelineItem";

import { OrderSubtype, LogbookOrderItem as LogbookOrderItemType } from "../../types";

const orderAccent = "#00897b";

export const ORDER_SUBTYPE_LABELS: Record<OrderSubtype, string> = {
	created: "Compra criada",
	paid: "Compra paga",
	created_and_paid: "Compra criada e paga",
};

type LogbookOrderItemProps = {
	order: LogbookOrderItemType;
	orderSubtype: OrderSubtype;
	entryDate: string;
	isSelected: boolean;
	onClick: () => void;
	linkUrl?: string;
};

export const LogbookOrderItem = ({ order, orderSubtype, entryDate, isSelected, onClick, linkUrl }: LogbookOrderItemProps) => {
	const orderLabel = ORDER_SUBTYPE_LABELS[orderSubtype];
	const itemNames = order.order_items
		?.map((item: any) => item.service_variant?.service?.name)
		.filter(Boolean)
		.join(", ");

	return (
		<BaseTimelineItem config={{
			accentColor: orderAccent,
			icon: <Euro sx={{ fontSize: 14, color: orderAccent }} />,
			isSelected,
			linkUrl,
		}}>
			<Box onClick={onClick} sx={{ flex: 1, cursor: "pointer" }}>
				<Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
					<Typography variant="body2" fontWeight={600} color={orderAccent}>{orderLabel}</Typography>
					{itemNames && (
						<Box sx={{ transform: "scale(0.8)", transformOrigin: "left" }}>
							<ColoredLabelChip label={itemNames} color={orderAccent} />
						</Box>
					)}
				</Box>
				<Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block", fontSize: "0.65rem" }}>
					{formatDateCompact(entryDate)}
				</Typography>
			</Box>
		</BaseTimelineItem>
	);
};
